<template>
  <div>
    <v-layout row wrap>
      <v-flex p-t-30>
        <div class="tituloBox p-b-30 border-top">
          <div class="bg-primary barraTitulo"></div>

          <v-btn icon @click="openBox()" right absolute>
            <v-icon>unfold_more</v-icon>
          </v-btn>

          <h1 class="text-info font-size-18">
            Habilitação
            <strong>Jurídica</strong>
          </h1>
        </div>
      </v-flex>
    </v-layout>

    <v-layout row wrap v-show="showBox">
      <v-flex infoDados>
        <v-card>
          <v-layout
            row
            wrap
            p-b-20
            v-for="item in documentosHabilitacaoJuridica"
            :key="item.codDocumento"
          >
            <v-flex sm6 p-l-none>
              <span class="linhaInfo">
                <v-icon>date_range</v-icon>
                Data do(a) {{titleCase(item.nomDocumento)}}:
                <strong class="text-cinza-6">{{item.docSolicitacao.datExpedicao | dataFormatada}}</strong>
              </span>
            </v-flex>

            <v-flex sm6>
              <span class="linhaInfo">
                {{'Anexo do(a) '+ titleCase(item.nomDocumento)}}:
              
                <a 
                    v-show="item.docSolicitacao.arquivoUpload && item.docSolicitacao.arquivoUpload !== 'Não Encontrado'"
                  >
                    <v-icon 
                      :color="
                        item.docSolicitacao.arquivoUploadSituacao === 2
                          ? 'blue' 
                          : (item.docSolicitacao.arquivoUploadSituacao === 1 
                            ? 'red' 
                            : 'grey')
                      "
                      :disabled="!(
                        item.docSolicitacao.arquivoUpload.includes('https') || 
                        (item.docSolicitacao.arquivoUploadSituacao === 1 && item.docSolicitacao.arquivoUpload.includes('.pdf'))
                      )"
                        @click.native="handleIconClick(item.docSolicitacao.arquivoUpload,item.docSolicitacao.arquivoUploadSituacao)"
                    >
                      attach_file
                    </v-icon>
                  </a>

                <span v-if="item.docSolicitacao.arquivoUpload === 'Não Encontrado'">
                  <strong
                    class="text-cinza-6"
                  >{{subStrUpload(item.docSolicitacao.arquivoUpload,'Anexo do(a) '+ titleCase(item.nomDocumento))}}</strong>
                </span>
              </span>
            </v-flex>
          </v-layout>

          <dirigentesTable :model="model" v-show="mostrarDirigente" />

          <sociosTable :model="model" v-show="mostrarSocio" />
        </v-card>
      </v-flex>
    </v-layout>
  </div>
</template>
<script>
import fornecedorService from "../../../services/fornecedorService";
import sociosTable from "./components/resumo-socios-table";
import dirigentesTable from "./components/resumo-dirigentes-table";
import documentosService from "../../../services/documentosFornecService";
import util from "../../../plugins/util"; /*Objeto com metodos e funcoes utilizadas pelo sistema */

export default {
  name: "resumo-hablitacao-juridica",
  mixins: [util],
  props: {//Propriedades que o objeto recebe como parametro
    model: Object, /*Solicitacao atual do Fornecedor*/
    dominio: Object,
    enums: Object
  },
  created() /*Metodo de start do componente*/{
    this.getDocumentos();
  },
  components: { /*Componentes utilizados*/
    dirigentesTable,
    sociosTable
  },

  computed: {//Campos computados
    mostrarDirigente() {
      //mostrar a listagem de dirigentes
      if (!this.model.fornecedoresHabilitacaoJuridica) return false;

      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "D"
      );

      if (lista.length) return true;
      else return false;
    },

    mostrarSocio() {
      //mostrar a listagem de socios
      if (!this.model.fornecedoresHabilitacaoJuridica) return false;

      let lista = this.model.fornecedoresHabilitacaoJuridica.filter(
        item => item.tipoCadastro === "S"
      );

      if (lista.length) return true;
      else return false;
    }
  },

  data() {//Declaracao de variaveis
    return {
      showBox: true,
      documentosHabilitacaoJuridica: Object
    };
  },

  methods: {//Declaracao de todos os metodos
    openBox() {
      this.showBox = !this.showBox;
    },
    handleIconClick(arquivo,situacao) {
        if (arquivo.includes('https')) {
          window.open(arquivo, '_blank');
        } else if (situacao === 1 && arquivo.includes('.pdf')) {
          this.baixarArquivo(arquivo);
        }
      },  
  
    baixarArquivo(arquivo) {        //baixar o documento
       
      const numCgcFornecedor = this.model.numCgcFornecedor.replace(/[\W_]+/g, "") ;
         
      fornecedorService.baixarArquivo(arquivo,numCgcFornecedor);
      },

    retornaEnumDescricao(_enum, valor) {
      //retorna a descricao do enum
      if (!valor || !this.enums[_enum]) return "";

      let retorno = this.enums[_enum].find(x => x.valor === valor);

      return retorno ? retorno.descricao : null;
    },
    getDocumentos() {
      //resgatar os documentos do fornecedor
      documentosService
        .getDocumentosFornecedorSolicitacao(this.model.idFornecSolicitacao)
        .then(documentos => {
          if (documentos.data.length > 0) {
            this.documentosHabilitacaoJuridica = documentos.data.filter(
              x => x.numHabilitacao === "2" && (x.docSolicitacao.datExpedicao || x.docSolicitacao.arquivoUpload)
            );
          }
        });
    }
  }
};
</script>

<style scoped> /*CSS especifico do componente*/
.infoDados .v-card {
  padding: 15px;
}

.infoDados .linhaInfo {
  display: block;

  padding: 5px 0;
}

.theme--light.v-table thead {
  background: none;
}
</style>


